import useTikTokAuthorizationStep from './useTikTokAuthorizationStep';

export default useTikTokAuthorizationStep;
